import { ScrollView, TextBox } from "devextreme-react";
import React, { useState, useEffect, useReducer, useRef } from "react";
import { alert } from "devextreme/ui/dialog";
import { v4 as uuidv4 } from "uuid";
const WhyAnalyzer = ({
  topLevelWhys,
  setTopLevelWhys,
  whyDescription,
  setwhyDescription,
}) => {
  const handleAddBranch = () => {
    if (
      whyDescription !== null &&
      whyDescription !== undefined &&
      whyDescription !== "" &&
      whyDescription.length > 0
    ) {
      const newSub = {
        id: uuidv4(),
        whyValue: "",
      };
      const newparentBranch = {
        id: uuidv4(),
        subwhys: [newSub],
      };

      setTopLevelWhys([...topLevelWhys, newparentBranch]);
    } else {
      alert("Please enter Problem Satement", "Alert");
      return;
    }
  };

  const removeBranch = (index, whyItem, item, whyIndex) => {
    const updatedItems = [...topLevelWhys];
    updatedItems.splice(index, 1);
    setTopLevelWhys(updatedItems);
  };

  const addWhy = (e, item1) => {
    const newSub = {
      id: uuidv4(),
      whyValue: "",
    };
    setTopLevelWhys((prevState) =>
      prevState.map((obj) => {
        if (obj.id === item1.id) {
          return { ...obj, subwhys: [...obj.subwhys, newSub] };
        }
        return obj;
      })
    );
  };

  const removeWhy = (index, whyindex) => {
    const updatedItems = [...topLevelWhys];
    updatedItems[index].subwhys.splice(whyindex, 1);
    setTopLevelWhys(updatedItems);
  };
  const handleInputChange = (e, subItem, parentItem) => {
    setTopLevelWhys((prevItems) => {
      return prevItems.map((item) => {
        if (item.id === parentItem.id) {
          const updatedSubWhys = item.subwhys.map((subval) => {
            if (subval.id === subItem.id) {
              return { ...subval, whyValue: e.value };
            }
            return subval;
          });
          return { ...item, subwhys: updatedSubWhys };
        }
        return item;
      });
    });
  };
  const handleDesInputChange = (e) => {
    setwhyDescription(e.value);
  };
  return (
    <div>
      <div style={{ justifyContent: "center", display: "flex" }}>
        <TextBox
          label="Problem Statement*"
          width={1150}
          value={whyDescription}
          onValueChanged={(e) => handleDesInputChange(e)}
        ></TextBox>
        <button
          onClick={() => handleAddBranch()}
          style={{
            float: "right",
            position: "relative",
            marginLeft: "1%",
            marginTop: "8px",
          }}
        >
          {" "}
          <i
            title="Delete"
            className="fas fa-plus"
            style={{ marginRight: "2px" }}
          ></i>
          Add Why Branch
        </button>
      </div>
      <div className="line-horizontal-why"></div>
      <div className="whycontent">
        {topLevelWhys?.map((item, index) => (
          <>
            <span onClick={() => removeBranch(index)} className="removebranch">
              -
            </span>
            <div className="whysubcontent">
              {item?.subwhys?.map((whyItem, whyIndex) => (
                <>
                  <div style={{ height: "65px" }}>
                    <span className="line-vertical-why"></span>
                    <TextBox
                      label={`Why ${whyIndex + 1}`}
                      width={380}
                      style={{
                        marginTop: "0px", // Note the correct camelCase for marginTop
                        position: "relative",
                        marginRight: "10px",
                        marginLeft: "5px",
                      }}
                      value={whyItem.whyValue}
                      onValueChanged={(e) => {
                        // Only trigger the event when data changes
                        if (e && e.component && e.event !== undefined) {
                          handleInputChange(e, whyItem, item);
                        }
                      }}
                    ></TextBox>
                    {whyIndex !== 0 ? (
                      <span
                        onClick={() => removeWhy(index, whyIndex)}
                        className="removewhy"
                      >
                        -
                      </span>
                    ) : null}
                  </div>
                </>
              ))}
              <div className="addwhy">
                <button onClick={() => addWhy(index, item)}>
                  {" "}
                  <i title="Add why" className="fas fa-plus"></i>
                  Add Why
                </button>
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default WhyAnalyzer;
